import StorageService from "./StorageService";
import axios from "axios";
import Cookies from 'js-cookie'
import { CONSTS } from "../config/Constant";
import { parseError, parseBody } from "../utils/requestUtils";
const API_URL = process.env.REACT_APP_API;
class ApiService {
  constructor() {
    if (!ApiService.instance) {
      console.log("CMS API_URL:", API_URL);

      this.client = axios.create({
        baseURL: API_URL,
        timeout: process.env.TIME_OUT || 30000,
        headers: {
          "Content-Type": "application/json;charset=utf-8"
        }
      });

      this.client.interceptors.request.use(
        config => {
          if (typeof window !== "undefined") {
            if (!document.body.classList.contains("show-indicator")) {
              document.body.classList.add("show-indicator");
            }
          }
          let token = StorageService.get(CONSTS.STORE_KEYS.USER.TOKEN);
          if(!token){
            token = Cookies.get('jwt');
          }
          if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
          }
          return config;
        },
        error => {
          if (typeof window !== "undefined") {
            document.body.classList.remove("show-indicator");
          }
          Promise.reject(error);
        }
      );

      this.client.interceptors.response.use(
        response => {
          if (typeof window !== "undefined") {
            setTimeout(() => {
              document.body.classList.remove("show-indicator");
            }, 5000);
          }
          return parseBody(response);
        },
        error => {
          if (typeof window !== "undefined") {
            document.body.classList.remove("show-indicator");
          }
          if (error.response) {
            return parseError(error.response.data);
          } else {
            return Promise.reject(error);
          }
        }
      );
    }

    return ApiService.instance;
  }

  get(url) {
    return this.client.get(url);
  }
  post(url, data) {
    return this.client.post(url, data);
  }
  put(url, data) {
    return this.client.put(url, data);
  }
  patch(url, data) {
    return this.client.patch(url, data);
  }
  delete(url) {
    return this.client.delete(url);
  }
}
const instance = new ApiService();
Object.freeze(instance);
export default instance;
